<template>
	<div class="tc-classes">
		<div class="tc-classes-body" v-bind:class="classClasses"></div>
		<v-icon small class="blue--text classes-icon" v-if="isShowClassIcon">local_offer</v-icon>
	</div>
</template>
<script>
export default {
	name: "Classes",
	props: [ 
		"items", 
		"max_width",
		"all_show",
		"is_show_icon"
		],
	methods: {
		display: function() {
			let el = this.$el.getElementsByClassName('tc-classes-body')[0];
			while (el.firstChild)
			el.removeChild(el.firstChild);
			let width = 0;
			for (let item of this.items) {
				let span = document.createElement('span');
				span.setAttribute('class', 'blue--text');
				span.innerHTML = '#' + this.getClassNameFromCode(item.code);
				el.appendChild(span);
				let span_width = span.offsetWidth + 3;	// add margin-right
				width += span_width;
				if (this.max_width < width) {
					if (this.all_show) {
						el.insertBefore(document.createElement('br'), span);
						width = span_width;
					} else {
						span.innerHTML = ' &gt;&gt;';
						break;
					}
				}
			}
			if (this.items.length == 0) {
				let span = document.createElement('span');
				span.innerHTML = '&nbsp;';
				el.appendChild(span);
			}
			return true;
		},
		getClassNameFromCode: function(code){
			let classe = this.$store.getters['class'](code);
			return classe.name;
		}
	},
	mounted: function() {
		this.display();
	},
	computed: {
		isShowClassIcon: function(){
			if (this.is_show_icon){
				return true;
			} else {
				return false;
			}
		},
		classClasses: function(){
			let classes = new Array();
			if (this.is_show_icon){
				classes.push('show-classes-icon');
			}
			return classes;
		}
	},
	watch: {
		items: {
			handler: function () {
				this.display();
			},
			deep: true,
		},
	},
	beforeDestroy: function() {
		while (this.$el.firstChild)
			this.$el.removeChild(this.$el.firstChild);
	},
};
</script>
<style>
	.tc-classes {
		position: relative;
	}
	.tc-classes{
		width: 100%;
	}
	.tc-classes-body{
		width: 100%;
		overflow: hidden;
		/*
		text-overflow: ellipsis;
		*/
		white-space: nowrap;
	}
	.tc-classes-body > span {
		font-size: .75em;
		margin-right: 3px;
	}
	.tc-classes-body.show-classes-icon{
		padding-left: 1.2rem;
	}
	.tc-classes .classes-icon{
		position: absolute;
		left: 0px;
		top: 3px;
		-webkit-transform: scale(1, -1);
		transform: scale(1, -1);
		font-size: 14px !important;
	}
</style>
